import React from 'react';

import { ListProps } from './list.types';
import { CategoriesList } from './categories-list';
import { useCategoriesList } from './use-categories-list';
import { StackedCard } from '../cards/stacked-card';

export const StackedList = ({ items, mobileDisplay, style, showHeading }: ListProps): JSX.Element => {
  const { isExpanded, viewAllItems } = useCategoriesList();

  return (
    <CategoriesList
      mobileDisplay={mobileDisplay}
      itemCount={items.length}
      isExpanded={isExpanded}
      viewAllItems={viewAllItems}
      showHeading={showHeading}
    >
      {items.map(({ category, image }, index) => (
        <StackedCard
          key={category}
          category={category}
          image={image}
          radius={style}
          mobileDisplay={mobileDisplay}
          isHidden={!isExpanded && index > 5}
        />
      ))}
    </CategoriesList>
  );
};
